var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_4133",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 4133",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.156,
    height: 40.156,
    viewBox: "0 0 40.156 40.156"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1661",
    "data-name": "\\u30D1\\u30B9 1661",
    d: "M20.078,0A20.078,20.078,0,1,1,0,20.078,20.078,20.078,0,0,1,20.078,0Z",
    fill: "#bcbcbc"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_3781",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 3781",
    transform: "translate(20.396 9) rotate(45)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_5",
    "data-name": "\\u7DDA 5",
    x2: 16.117,
    transform: "translate(0 8.059)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_6",
    "data-name": "\\u7DDA 6",
    x2: 16.117,
    transform: "translate(8.059 0) rotate(90)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 4
  }))));
};
export default SvgClose;